import React, { useEffect, useState } from "react";
import BannerVideo from "../BannerVideo";
import MultiScroll from "../MultiScroll";
import InfoMultiGridSchool from "../InfoMultiGridSchool";
import ExecutiveInformation from "../ExecutiveInformation";
import FeeRange from "../FeeRange";
import SchoolGrade from "../SchoolGrade";
import ContentArticle from "../ContentArticle";
import AccreditationContent from "../AccreditationContent";
import ParentPortalBanner from "../ParentPortalBanner";
import InfoGridTextLeft from "../InfoGridTextLeft";
import InfoGridText from "../InfoGridText";
import GoogleMaps from "../GoogleMaps";
import AlumniFAQ from "../AlumniFAQ";
import EnquireButton from "../EnquireButton";
import ScrollingPartnership from "../ScrollingPartnership";
import { fetchRelatedSchoolCardData } from "../../service/api";
import { useDispatch, useSelector } from "react-redux";
import { fetchPageSearchData, selectData } from "../../redux/dataSlice";
import { processCtaPopUpData, processSchoolData } from "../../utils/mappingSchool";
import { useRouter } from "next/router";
import PageLoadPopUp from "../PageLoadPopUp";
import { applicationLabelFetchData } from "@/parentService/parentApi";

const SchoolContent = () => {
  const data = useSelector(selectData);
  const processedData = processSchoolData(data);

  const dispatch = useDispatch();
  const router = useRouter();
  const { slug } = router?.query;

  const [showPopup, setShowPopup] = useState(false);
  const [ctaPopupData, setCtaPopupData] = useState(null);

  useEffect(() => {
    if (!slug) return;

    if (slug == "cranleigh-abu-dhabi") {
      setShowPopup(true);
      const fetchPopUp = async() => {
        try {
          const res = await applicationLabelFetchData("school-cta-popup")
          let data = processCtaPopUpData(res?.data);
          setCtaPopupData(data);
        } catch (error) {
          console.error("Error fetching related school data:", error);
        }
      }
      fetchPopUp();
    }
  }, [slug]);



  useEffect(() => {
    const fetchData = async () => {
      try {
        const ids = processedData?.relatedschools
          ?.map((item) => item.id)
          .join(",");

        if (ids) {
          const response = await fetchRelatedSchoolCardData(ids);
          dispatch(fetchPageSearchData(response?.data?.data));
        } else {
          dispatch(fetchPageSearchData(null));
        }
      } catch (error) {
        console.error("Error fetching related school data:", error);
      }
    };

    fetchData();
  }, [processedData?.relatedschools]);

  return (
      <div
        className="main school-details-page"
        data-testid="school-content-container-id"
      >
        <PageLoadPopUp showPopup={showPopup} setShowPopup={setShowPopup} />
        <ContentArticle titleData={processedData?.stateSpeaksTitle} />
        <SchoolGrade data={processedData?.stateSpeaks} />
        <BannerVideo data={processedData?.bannerVideo} isStyles={true} />
        <ExecutiveInformation
          data={processedData?.executiveInfo}
          desc={processedData?.executiveInfoDesc}
          color={processedData?.buttoncolor}
        />

        <MultiScroll
          data={processedData?.MultiScroll}
          color={processedData?.buttoncolor}
          bgColor={processedData?.backgroundcolor}
        />
        <AccreditationContent datas={processedData?.accreditation} />
        <ContentArticle titleData={processedData?.feeRangeTitle} isCurriculum />
        <FeeRange 
          data={processedData?.feeRange} 
          ctaPopupData={ctaPopupData}
        />
        <InfoMultiGridSchool
          data={processedData?.InfoGridData}
          color={processedData?.buttoncolor}
          bgColor={processedData?.backgroundcolor}
          ctaPopupData={ctaPopupData}
        />
        <InfoGridTextLeft data={processedData?.schoolFacilities} isStyle />
        <InfoGridText data={processedData?.scholarshipProgram} isSchool />
        <AlumniFAQ data={processedData?.faqs} />
        <ParentPortalBanner data={processedData?.parentTour} />
        <GoogleMaps data={processedData?.maplocator} />
        <EnquireButton
          data={processedData?.enquireNow}
          color={processedData?.buttoncolor}
        />
        <ContentArticle
          titleData={processedData?.relatedschoolTitle}
          isCurriculum
        />
        {processedData?.relatedschools?.length > 0 && <ScrollingPartnership />}
      </div>
  );
};

export default SchoolContent;
